require('./brokerInternalTransferFundContributionStep.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');

// @ components
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ commons
const { AmountInput } = require('commonsComponents/amountInput');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const { PROC_BROKER_FUNDS_PG_NAME } = require('utilities/tagging.js');

// @ constants
const { FIRST_STEP, HYPHEN } = require('constants/index');
const {
  DATE_PICKER_CUSTOM_PLACEHOLDER,
  DATE_PICKER_CUSTOM_LOCALE,
  DATE_PICKER_CUSTOM_DATE_FORMAT,
} = require('constants/commonsComponents');
const BrokerInterestModal = require('../brokerInterestModal/brokerInterestModal');
const language = getLanguage();

class BrokerInternalTransferFundContributionStep extends React.Component {
  constructor(props) {
    super(props);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handlePeriodicityChange = this.handlePeriodicityChange.bind(this);
    this.handleClickDeleteAmount = this.handleClickDeleteAmount.bind(this);
    this.handleAmountBlur = this.handleAmountBlur.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handleDatePickerError = this.handleDatePickerError.bind(this);
    this.handleToggleModal = this.handleToggleModal.bind(this);
    this.state = {
      showInterestModal: false,
    };
  }

  componentDidMount() {
    const { isin } = this.props;
    taggingEventHandled(PROC_BROKER_FUNDS_PG_NAME, 'contributionFundStep1', isin);
    this.props.skipContributionStep(false);
  }

  handleDateChange(date) {
    this.props.setValidityDate(date);
  }

  handlePeriodicityChange(value) {
    this.props.setPeriodicity(value);
  }
  handleClickDeleteAmount() {
    this.props.setAmount(0);
  }
  handleAmountBlur(value) {
    this.props.setAmount(value);
  }
  handleAmountChange(value) {
      this.props.setAmount(value);
  }

  handleDatePickerError(error) {
    this.props.setDatePickerError(error);
  }
  handleToggleModal = () => {
    this.setState({ showInterestModal: !this.state.showInterestModal });
  };

  handleSkipContributionLink = () => {
    this.props.skipContributionStep(true);
  };
  
  buildRemoveIcon() {
    return (
      <span
        onClick={() => this.handleClickDeleteAmount()}
        className="transfer-contribution-investment-step__icon-amount" 
      >
        <i class="custom-notification__icon icon-agregar"></i>
      </span>
    );
  }


  buildInput() {
    const { amount, amountErrorState, amountErrorMsg, customMinimumPurchaseAmount } = this.props;
    const currency = customMinimumPurchaseAmount.currency
    const minimunAmount = customMinimumPurchaseAmount.amount;
    const plainAmountObject = getPlainAmountObject(customMinimumPurchaseAmount);
    plainAmountObject.decimalsLength = 3;
    const removeIcon = amount !== 0 ? this.buildRemoveIcon() : null;
    const onlineSymbolObject = currency && minimunAmount ?
                (<OneLineSymbolAmount
                    truncate={false}
                    amountObject={plainAmountObject}
                    language={language}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />)
                : HYPHEN;

    return (
      <div className="transfer-contribution-investment-step__input-container">
        <FormattedText
            value="brokerContributionFundStep1-amount2"
            className="transfer-contribution-investment-step__associated-cc-amount"
            injectedStrings={[`(${currency.toUpperCase()})`]}
        />
        <div className="transfer-contribution-investment-step__amount-box">
          <div
          >
              <AmountInput
                amount={amount}
                callback={this.handleAmountBlur}
                onChange={this.handleAmountChange}
                error={amountErrorState}
                errorMsg={amountErrorMsg}
                hideFocusZero={true}
                showBlurZero={true}
                language={language}
              />
          </div>
          {removeIcon}
        </div>
        <div className="transfer-contribution-investment-step__associated-cc-minimal">
          <FormattedText 
            value={'brokerContributionFundStep1-miniumAmountText1'}
          />
          {onlineSymbolObject}
          <FormattedText 
            value={'brokerContributionFundStep1-miniumAmountText2'}
          />
        </div>
      </div>
    );
  }

  createMonthlyDropdown() {
    const { periodicityError, periodicityValue, periodicityOptions, periodicityErrorMsg } = this.props;

    return (
      <div className={`transfer-contribution-investment-step__select`}>
        <OKSelect
          label={formatText('brokerContributionFundStep1-priodicityLabel')}
          onChange={this.handlePeriodicityChange}
          options={periodicityOptions && periodicityOptions.toJS()}
          value={periodicityValue}
          autosize={false}
          placeholder={''}
          errorState={periodicityError}
          errorMessage={periodicityErrorMsg}
          searchable={false}
        />
      </div>
    );
  }

  createDatePicker() {
    const { selectedDate, minDate } = this.props;

    return (
      <span className="transfer-contribution-investment-step__date-picker">
        <DatePickerCustom
          callback={this.handleDateChange}
          selectedDate={selectedDate}
          label={formatText('brokerContributionFundStep1-datePickerLabel')}
          placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
          locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
          dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
          disabled={false}
          minDate={minDate}
          startDate={minDate}
          newSelectedDate={selectedDate}
          callbackError={this.handleDatePickerError}
        />
      </span>
    );
  }

  render() {
    const title = formatText('brokerContributionFundStep1-title');

    const inputs = (
      <div className="transfer-contribution-investment-step__periodicly-box">
        {this.buildInput()}
        {this.createMonthlyDropdown()}
        {this.createDatePicker()}
      </div>
    );

    return (
      <div className="transfer-contribution-investment-step">
        <header className="transfer-contribution-investment-step__header">
          <h2 className="transfer-contribution-investment-step__title">
            {title}
          </h2>
          <FormattedText value="brokerContributionFundStep1-descriptionFirst"/>
          <OKButton modifier="link-emphasize" onClick={this.handleToggleModal}>
            {formatText('brokerContributionFundStep1-descriptionLink')}
          </OKButton>
          <FormattedText value="brokerContributionFundStep1-descriptionSecond"/>
        </header>
        {inputs}
        <div className="transfer-contribution-investment-step__skip-contribution">
          <OKButton modifier="link-complementary" onClick={this.handleSkipContributionLink}>
              {formatText('brokerContributionFundStep1-skipContributionLink')}
          </OKButton> 
        </div>
        <BrokerInterestModal
          isOpen={this.state.showInterestModal}
          onCloseCallback={this.handleToggleModal}
        />
      </div>
    );
  }
}

BrokerInternalTransferFundContributionStep.propTypes = {
  isin: PropTypes.string.isRequired,
  onStepChange: PropTypes.func,

  customMinimumPurchaseAmount: PropTypes.number,
  amount: PropTypes.number,
  amountErrorState: PropTypes.bool,
  errorMsg: PropTypes.string,
  setAmount: PropTypes.func,
  onClickDeleteAmount: PropTypes.func.isRequired,

  periodicityError: PropTypes.bool,
  periodicityErrorMsg: PropTypes.string,
  periodicityValue: PropTypes.string,
  periodicityOptions: PropTypes.array,
  setPeriodicity: PropTypes.func.isRequired,

  setValidityDate: PropTypes.func.isRequired,
  selectedDate: PropTypes.object,
  minDate: PropTypes.object,
  setDatePickerError: PropTypes.func,
  skipContributionStep: PropTypes.func,
};

module.exports.BrokerInternalTransferFundContributionStep = BrokerInternalTransferFundContributionStep;